import React from "react";
import { Capabilities, capabilitiesNaming, FacilityStatus, facilityStatusNaming } from "../../api/typesDc";
import { useTranslation } from "react-i18next";
import AutoComplete from "../AutoComplete";
import { isEmpty } from "../../common/StaticExports";

const CapablitiesAutocomplete = (props:any) => {
    const { selectedValues, manageSelect, isReadOnly } = props;
    const [t] = useTranslation();
    const options = [
      { value: Capabilities.CAP_CLUB_HOUSE, name: t(capabilitiesNaming[Capabilities.CAP_CLUB_HOUSE]) },
      { value: Capabilities.CAP_MEDICAL_ROOM, name: t(capabilitiesNaming[Capabilities.CAP_MEDICAL_ROOM]) },
      { value: Capabilities.CAP_COLD_SHOWERS, name: t(capabilitiesNaming[Capabilities.CAP_COLD_SHOWERS]) },
      { value: Capabilities.CAP_HOT_SHOWERS, name: t(capabilitiesNaming[Capabilities.CAP_HOT_SHOWERS]) },
      {
        value: Capabilities.CAP_SOCCER_GOAL_POSSESSION_ADULT,
        name: t(capabilitiesNaming[Capabilities.CAP_SOCCER_GOAL_POSSESSION_ADULT]),
      },
      {
        value: Capabilities.CAP_SOCCER_GOAL_POSSESSION_JUNIOR,
        name: t(capabilitiesNaming[Capabilities.CAP_SOCCER_GOAL_POSSESSION_JUNIOR]),
      },
      {
        value: Capabilities.CAP_SOCCER_GOAL_POSSESSION_KIDS,
        name: t(capabilitiesNaming[Capabilities.CAP_SOCCER_GOAL_POSSESSION_KIDS]),
      },
      { value: Capabilities.CAP_DORMITORY, name: t(capabilitiesNaming[Capabilities.CAP_DORMITORY]) },
      { value: Capabilities.CAP_CHANGING_ROOMS, name: t(capabilitiesNaming[Capabilities.CAP_CHANGING_ROOMS]) },
    ];

    const manageCapablitiesSelect = (d:any) => {
      let tempCapablities = [];
      const index = selectedValues.findIndex((item:any) => item == d.value);
      if(index !== -1) {
        tempCapablities = selectedValues.filter((item:any) => item != d.value);
      } else {
        tempCapablities = [...selectedValues, d.value];
      }
      manageSelect(tempCapablities);
    }

    return (
        <>
            <AutoComplete 
            options={options}
            selectedValues={selectedValues}
            handleMenuClick={manageCapablitiesSelect} 
            label={t('DC_6_CAPABILITIES')}
            clickReset={() => {manageSelect([])}}
            isMultiple={true}
            isError={isEmpty(selectedValues)}
            errorMessage={t('REQUIRED')}
            isReadOnly={isReadOnly}
            />
        </>
    );
}

export default CapablitiesAutocomplete;